module.exports = __webpack_public_path__ + "img/role-no-user-data.9a1b62e5.png";